import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { removeCookie, deleteCookie } from 'utils';
import { useAuthCheck, useSocialLogin } from 'hooks/AuthHooks';
import MessageAlert from 'utils';
import { useUserAction } from 'store';
import { encrypt } from 'utils/Crypto';

const SocialLogin = (props) => {
  /* ===== Route ===== */
  const { navigate, location } = props;
  const [searchParams] = useSearchParams();
  // 파라미터 추출
  const type = searchParams.get('type');
  const code = searchParams.get('code');

  const from = location.state?.from || '/main';

  /* ===== Store =====*/
  // User
  const userAction = useUserAction();

  /* ===== Mutate =====*/
  // 토큰 검증
  const { authCheck } = useAuthCheck();

  /* ===== Data =====*/
  // 소셜 로그인
  const { data: socialUser, refetch } = useSocialLogin(
    type &&
      code && {
        type,
        code,
        platform: /Android|iPhone/i.test(navigator.userAgent) ? 'MOBILE' : 'PC',
      },
  );

  /* ===== Props ===== */
  /* ===== State ===== */
  /* ===== Function ===== */
  /**
   * 토큰 검증
   * --
   */
  const handleTokenCheck = async () => {
    // 토큰 검증
    try {
      const { status, data, message } = await authCheck();

      // NOTE: 검증 실패 처리
      if (status !== 200) {
        userAction.resetUser();
        deleteCookie('JM_COFFEE_ACCESS_TOKEN', {});
        return;
      }

      // NOTE: 검증 성공
      userAction.setUser(data);
      navigate(from, { replace: true });
    } catch (err) {
      MessageAlert.error('로그인 중 오류가 발생하였습니다!');
      console.error('[AUTH] ERROR!! ', err);
      throw err;
    }
  };

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /**
   * 소셜로그인 코드, 타입 감지
   * --
   */
  useEffect(() => {
    if (code && type) {
      refetch();
    }
  }, [type, code, refetch]);

  /**
   * 데이터 변환에 따른 로그인 및 회원가입 처리
   * --
   */
  useEffect(() => {
    if (socialUser) {
      // NOTE: 모바일인지 체크
      const isMobile = window.ReactNativeWebView;

      const { status, data } = socialUser;
      //결과
      if (status === 200) {
        const { account_status, token } = data;

        // NOTE: 소셜 로그인
        // NOTE: 소셜로 가입된 계정이 없을 경우
        if (!token) {
          const confirm = window.confirm(
            `해당 소셜과 연동된 계정이 존재하지 않습니다. 회원가입 후 연동하시겠습니까?`,
          );

          if (!confirm) {
            if (isMobile) {
              const message = {
                type: 'CANCEL',
              };
              window.ReactNativeWebView.postMessage(JSON.stringify(message));
              return;
            } else {
              navigate(`/signin`);
              return;
            }
          } else {
            //소셜 회원가입처리
            if (isMobile) {
              // 모바일일경우
              const message = {
                type: 'SIGNUP',
                data: data,
              };
              window.ReactNativeWebView.postMessage(JSON.stringify(message));
              return;
            } else {
              // PC일 경우
              navigate(
                `/signup?social=${encodeURIComponent(
                  encrypt(JSON.stringify(data)),
                )}`,
              );
              return;
            }
          }
        } else {
          // NOTE: 계정 상태별 처리
          switch (account_status) {
            //비활 , 탈퇴 -> 로그인 불가
            case 'INACTIVE':
            case 'WITHDRAWN':
              MessageAlert.warning(
                '로그인 불가한 계정입니다. 관리자에 문의해주세요.',
              );
              if (isMobile) {
                // 모바일일경우
                const message = {
                  type: account_status,
                };
                window.ReactNativeWebView.postMessage(JSON.stringify(message));
              } else {
                navigate(`/signin`);
              }
              return;

            //휴면 -> 본인인증
            case 'DORMANT':
              MessageAlert.warning(
                '휴먼 계정입니다. 본인인증 완료 후 로그인해주세요.',
              );
              if (isMobile) {
                const message = {
                  type: 'DORMANT',
                };
                window.ReactNativeWebView.postMessage(JSON.stringify(message));
              } else {
                navigate(`/signin`);
              }
              return;
            default:
              if (isMobile) {
                const message = {
                  type: 'SIGNIN',
                  data: data,
                };
                window.ReactNativeWebView.postMessage(JSON.stringify(message));
              } else {
                // NOTE: 쿠키 저장 시간 설정
                const saveTime = 8 * 60 * 60 * 1000; // 8h
                removeCookie('JM_COFFEE_ACCESS_TOKEN', token, saveTime);

                // NOTE: 토큰 검증
                handleTokenCheck();
              }
              return;
          }
        }
      } else {
        MessageAlert.error('소셜로그인에 실패하였습니다.');
        if (isMobile) {
          const message = {
            type: 'FAIL',
          };
          window.ReactNativeWebView.postMessage(JSON.stringify(message));
          return;
        } else {
          navigate(`/signin`);
        }
      }
    }
    return;
    // eslint-disable-next-line
  }, [socialUser]);

  /* ===== Render ===== */
  return (
    <div>
      <div></div>
    </div>
  );
};

export default SocialLogin;
